import { render, staticRenderFns } from "./TheAssessmentChart.vue?vue&type=template&id=378b8a38&scoped=true&"
import script from "./TheAssessmentChart.vue?vue&type=script&lang=js&"
export * from "./TheAssessmentChart.vue?vue&type=script&lang=js&"
import style0 from "./TheAssessmentChart.vue?vue&type=style&index=0&id=378b8a38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378b8a38",
  null
  
)

export default component.exports